import Layout from '../../components/layout/layout'

export default function CookiePolicy({siteConfig}) {
  return (
    <Layout  siteConfig={siteConfig} isFixed={true} >

    <div className="bg-white px-6 py-32 lg:px-8">
      <div dangerouslySetInnerHTML={{ __html: siteConfig?.terms_conditions?.content ?? '' }} />
    </div>

    </Layout>

  )
}
